import React, { useCallback, useEffect, useState } from 'react';
import { createContainer } from 'react-tracked';
import { CHAINS } from '../constants';
import { useGlobalState } from '../state/GlobalStateProvider';
import { useBackendApi } from './backendHelper';

const HEADINGS = {
  alreadyPosted: 'Already Posted',
  notEligible: 'Not Eligible',
  eligible: 'Eligible To Post',
};

const DISABLED_CATEGORIES = new Set(['notEligible']);

const useTakesHelper = () => {
  const backendHelper = useBackendApi();
  const [{ protocolMapping, user }] = useGlobalState();

  const [state, setState] = useState();

  const setValue = (key, value) => setState(state => ({ ...state, [key]: value }));

  const handleProtocol = useCallback(
    (item, category) => {
      if (String(item?.protocol).startsWith('chain')) {
        return {
          ...item,
          disabled: DISABLED_CATEGORIES.has(category),
          ...(CHAINS?.[String(item?.protocol).split('-')[1]] || {}),
        };
      }
      return {
        ...item,
        disabled: DISABLED_CATEGORIES.has(category),
        ...(protocolMapping?.[item?.protocol] || {}),
      };
    },
    [protocolMapping],
  );

  const getSuperTakeEligible = useCallback(async () => {
    try {
      const data = await backendHelper.reviews.superTakeEligibileProtocols();
      setValue('superTakeEligibile', new Set([...(data?.data || [])]));
    } catch (error) {
      console.log('Error is getting EligibileProtocols', error);
      setValue('superTakeEligibile', new Set([]));
    }
  }, [backendHelper]);

  const getEligibleProtocols = useCallback(async () => {
    try {
      const data = await backendHelper.reviews.getReactionEligible();
      setValue('eligibleProtocols', new Set([...(data?.data || [])]));
    } catch (error) {
      console.log('Error is getting EligibileProtocols', error);
      setValue('eligibleProtocols', new Set([]));
    }
  }, [backendHelper]);

  const getReviewedProtocol = useCallback(async () => {
    try {
      const data = await backendHelper.reviews.userProtocolStatsWithRating();
      const rawData = data.data;
      const transformedData = Object.entries(rawData).reduce((acc, [category, items]) => {
        acc[HEADINGS[category] ? HEADINGS[category] : category] = items.map(item => handleProtocol(item, category));
        return acc;
      }, {});
      setValue('projectStatus', transformedData);
    } catch (error) {
      console.log('error is getting reviwedProtocol', error);
    }
  }, [backendHelper, handleProtocol]);

  const getAllReviewTags = useCallback(async () => {
    try {
      const response = await backendHelper.reviews.getAllReviewsTag();
      setValue('allReviewTags', response.data);
    } catch (error) {
      console.log('error is getting reviewTags', error);
    }
  }, [backendHelper]);

  function resetData() {
    setValue('eligibleProtocols', new Set([]));
    setValue('superTakeEligibile', new Set([]));
  }

  useEffect(() => {
    //getAllReviewTags, getReviewedProtocol, getEligibleProtocols, getSuperTakeEligible
  }, []);

  useEffect(() => {
    if (!user) {
      return resetData();
    }

    getAllReviewTags();
    getEligibleProtocols();
    getSuperTakeEligible();
  }, [user]);

  useEffect(() => {
    if (!protocolMapping) return;
    getReviewedProtocol();
  }, [protocolMapping]);

  return [{ ...state, getReviewedProtocol, reactionEligible: new Set([...(state?.eligibleProtocols || []), ...(state?.superTakeEligibile || [])]) }, setState];
};

const { Provider, useTracked } = createContainer(() => useTakesHelper());

export const useTakesState = useTracked;
export const TakesStateProvider = ({ children }) => <Provider>{children}</Provider>;
export default TakesStateProvider;
